import { useEffect, useState } from "react";
import { shouldLoadContentImmediately } from "./utils"; // Ensure this import is correct

const useIntersectionObserver = (
  elementRef,
  callback,
  options = { threshold: 0.1 }
) => {
  const [isContentLoaded, setIsContentLoaded] = useState(false);

  useEffect(() => {
    const bypass = shouldLoadContentImmediately(); // Use the utility function

    if (bypass) {
      callback();
      setIsContentLoaded(true);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        callback();
        setIsContentLoaded(true);
      }
    }, options);

    const currentElement = elementRef.current;
    if (currentElement) {
      observer.observe(currentElement);
    }

    return () => {
      if (currentElement) {
        observer.unobserve(currentElement);
      }
    };
  }, [elementRef, callback, options]);

  return isContentLoaded;
};

export default useIntersectionObserver;
